import { shortDateOf, shortDateTimeOf } from "@repo/helpers";
import { Loading } from "@repo/ui";
import { FC } from "react";

import { useLocationQueries } from "../../api/locationApi";
import { StatusDot } from "../../components/statusDot";
import { useLocationContext } from "../../contexts/editableItemContext";
import style from "./style.module.scss";

export const StatusHistory: FC = () => {
	const { locationId } = useLocationContext();
	const { useStatusHistoriesQuery } = useLocationQueries();
	const { data: history, loaded } = useStatusHistoriesQuery(locationId);

	return (
		<Loading loading={!loaded}>
			<div className={style.timelineContainer}>
				{history?.map((item) => (
					<div key={item.id} className={style.timelineItem}>
						<div className={style.timelineMarker}>
							{/* TODO: Need a better way to do this */}
							<StatusDot statusId={item.statusId} />
							<div className={style.timelineConnector} />
						</div>
						<div className={style.timelineContent}>
							<div className={style.historyCard}>
								<div className={style.historyCardHeader}>
									<span className={style.statusAction}>
										<span className={style.action}>{item.action}</span>
										<span>
											<span className={style.statusName}>{item.statusName}</span>
										</span>
									</span>
									<div>
										Effective: &nbsp;
										<span className={style.historyDate}>
											{shortDateOf(item.startDate ?? item.createdOn)}
											{item.endDate ? ` - ${shortDateOf(item.endDate)}` : ""}
										</span>
									</div>
								</div>
								<div className={style.historyCardContent}>
									{item.notes && <p className={style.historyNotes}>{item.notes}</p>}
									<div className={style.historyFooter}>
										<span>
											Created <strong>{shortDateTimeOf(new Date(item.createdOn))}</strong> by{" "}
											<strong>{item.createdBy}</strong>
										</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				))}
				{loaded && history?.length === 0 && <div className={style.noHistory}>No status history found.</div>}
			</div>
		</Loading>
	);
};
